import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Instagram, Clock, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { BRAND, whatsappLink } from "../data/brand";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-[#0B1226] text-slate-300"
    >
      <div className="pointer-events-none absolute -top-32 left-1/4 h-72 w-72 rounded-full bg-[#1E3A8A] blob" />

      <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-12">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Centro Quirúrgico Veterinario CEQVet. Atención profesional y
              humana para tu mascota en {BRAND.city}.
            </p>
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/10 px-3 py-1.5 text-xs text-white hover:bg-white/5"
            >
              <Instagram className="h-3.5 w-3.5" /> @{BRAND.instagram}
              <ArrowUpRight className="h-3 w-3" />
            </a>
          </div>

          <div>
            <h4 className="font-display text-sm font-medium uppercase tracking-[0.18em] text-white">
              Navegación
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="/#servicios" className="hover:text-white">
                  Servicios
                </a>
              </li>
              <li>
                <a href="/#sobre-nosotros" className="hover:text-white">
                  Sobre nosotros
                </a>
              </li>
              <li>
                <a href="/#galeria" className="hover:text-white">
                  Galería
                </a>
              </li>
              <li>
                <a href="/#testimonios" className="hover:text-white">
                  Testimonios
                </a>
              </li>
              <li>
                <Link to="/reserva" className="hover:text-white">
                  Reservar hora
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-medium uppercase tracking-[0.18em] text-white">
              Contacto
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 text-[#EA580C]" />
                <span>{BRAND.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="mt-0.5 h-4 w-4 text-[#25D366]" />
                <a href={whatsappLink()} className="hover:text-white">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 text-[#1E3A8A]" />
                <a
                  href={`mailto:${BRAND.email}`}
                  className="hover:text-white break-all"
                >
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-medium uppercase tracking-[0.18em] text-white">
              Horarios
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              {BRAND.hours.map((h) => (
                <li key={h.day} className="flex items-center gap-2">
                  <Clock className="h-3.5 w-3.5 text-slate-500" />
                  <span className="text-slate-400">{h.day}:</span>
                  <span className="text-white">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
          <span>
            © {new Date().getFullYear()} CEQVet · Centro Quirúrgico Veterinario.
            Todos los derechos reservados.
          </span>
          <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">
            Acceso administrativo
          </Link>
        </div>
      </div>
    </footer>
  );
}
